import type { AdsLandingSectionHeader } from "./types";

export function SectionHeader({ header }: { header: AdsLandingSectionHeader }) {
  return (
    <div className="text-primary mx-auto flex max-w-[744px] flex-col items-center gap-8 px-6 text-center lg:px-0">
      {header.eyebrow ?
        <p className="text-secondary text-sm leading-none font-medium tracking-normal">
          {header.eyebrow}
        </p>
      : null}
      <div className="flex flex-col gap-6">
        <h2 className="mx-auto text-[48px] leading-[1.16] font-medium text-balance">
          {header.headline}
        </h2>
        {header.subhead ?
          <p className="text-primary mx-auto text-[17px] leading-7 text-balance">
            {header.subhead}
          </p>
        : null}
      </div>
    </div>
  );
}
